import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "battery",
  "use": "battery-usage",
  "viewBox": "0 0 130.83 68",
  "content": "<symbol viewBox=\"0 0 130.83 68\" id=\"battery\"><title>资源 23</title><g id=\"battery_图层_2\" data-name=\"图层 2\"><g id=\"battery_图层_1-2\" data-name=\"图层 1\"><path d=\"M10.88,57.12h87V10.88h-87Zm113.7-34.54V11.42A11.79,11.79,0,0,0,112.61,0H12A11.79,11.79,0,0,0,0,11.42V56.85A11.74,11.74,0,0,0,12,68H112.88a11.79,11.79,0,0,0,12-11.42V45.15a5.81,5.81,0,0,0,6-5.71V28A6.22,6.22,0,0,0,124.58,22.58Zm-6,5.71V56.58a5.81,5.81,0,0,1-6,5.71H12a5.81,5.81,0,0,1-6-5.71V11.42a5.81,5.81,0,0,1,6-5.71H112.88a5.81,5.81,0,0,1,6,5.71V28.29Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/battery.svg
// module id = q4P9
// module chunks = 264